import { createAction } from "@reduxjs/toolkit";

export const changeLanguage = createAction("lang/changeLang")

export const changeLang = (lang) => dispatch => {
  localStorage.setItem("lang", lang);
  dispatch(changeLanguage(lang))
};